import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ApiMethod } from "../apimethods/api-method";
import { ExceptionReportApiModel } from "./exceptioReport-model";
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from "../common/customfunctions";
import { GlobalConstants } from "../common/global-constants";
declare var $;

@Component({
  selector: "app-exception-report",
  templateUrl: "./exception-report.component.html",
  styleUrls: ["./exception-report.component.css"]
})
/** Exception-report component*/
export class ExceptionReportComponent implements OnInit {
  modelItem = new ExceptionReportApiModel();
  @ViewChild("dataTable") table;

  dataTable: any;
  dataSet: any;

  ngOnInit() {
    $('#divTackingDataList').css('height', (GlobalConstants.size.height) - 180);
    ApiMethod.getBaseUrl();
  }

  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <ExceptionReportApiModel>data["ExceptionReportPage"];
        this.getExceptionReportList();
        this.setDateValues();

        $(".select2").select2();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }


  getExceptionReportList() {
    $("#LoadingImage").show();

    var fromDate = $("#Txt_FromDate").val();
    var toDate = $("#Txt_ToDate").val();

    if (fromDate == "" || toDate == "")
      this.setDateValues();

    fromDate = $("#Txt_FromDate").val();
    toDate = $("#Txt_ToDate").val();

    var exceptionData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      FromDate: fromDate.toString(),
      ToDate: toDate.toString()
    };

    if ($('a.active')[0].text == 'Exception') {
      ApiMethod.postMethod(this.modelItem.ReportAPI, exceptionData).subscribe(
        result => {
          $("#LoadingImage").hide();
          this.dataSet = JSON.stringify(result.aitemList);
          this.dataSet = JSON.parse(this.dataSet);
          this.dataTable = $(this.table.nativeElement);

          //Dynamic datable
          let acolList = result.acolListL;
          let dataItem = new DataParam();
          dataItem.acolList = acolList;
          dataItem.aNewButtonName = 'btn_AddNew';
          dataItem.dataTable = this.dataTable;
          dataItem.dataset = this.dataSet;
          dataItem.dtheight = (GlobalConstants.size.height - 250);
          dataItem.modulename = 'ExceptionReportModule';
          dataItem.infoPopupID = '';
          dataItem.isDefault = false;
          this.dataTable = customfunctions.dynamicDataTable(dataItem);
          //Dynamic datable

        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "error");
        });
    }
    else if ($('a.active')[0].text == 'Tracking') {
      ApiMethod.postMethod(this.modelItem.AppTrackingAPI, exceptionData).subscribe(
        result => {
          $("#LoadingImage").hide();

          let itemList = result.aitemList;

          var zTableList = '<div class="DivList"><table width="100%">';
          let artId = 0;
          $.each(itemList, function (e, val) {

            zTableList += '<tr>';
            zTableList += '<td style="border: 1px solid;vertical-align: top;">' + val.Id + '</td>';
            zTableList += '<td style="border: 1px solid;vertical-align: top;">' + GlobalConstants.FormatDateTime(val.CreatedTime) + '</td>';
            zTableList += '<td style="border: 1px solid;vertical-align: top;">' + val.CalledApiUrl + '</td>';
            zTableList += '<td style="border: 1px solid;vertical-align: top;">' + val.UserAgentDetails + '</td>';
            zTableList += '<td style="border: 1px solid;vertical-align: top;">' + val.Payload + '</td>';

            zTableList += '</tr>';
          });
          zTableList += '</table></div>';

          $('#divTackingDataList').html(zTableList);

        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "error");
        });
    }
  }

  getFiltered() {
    this.getExceptionReportList();
  }

  resetFilter() {
    this.setDateValues();
    this.getExceptionReportList();
  }


  setDateValues() {
    var now = new Date();

    var currentDay = ("0" + now.getDate()).slice(-2);
    var currentMonth = ("0" + (now.getMonth() + 1)).slice(-2);
    var currentDate = now.getFullYear() + "-" + (currentMonth) + "-" + (currentDay);
    $("#Txt_ToDate").val(currentDate);

    var preDate = new Date(now.setDate(now.getDate() - 7));
    var prevDay = ("0" + (preDate.getDate())).slice(-2);
    var prevMonth = ("0" + (preDate.getMonth() + 1)).slice(-2);
    var prevToday = preDate.getFullYear() + "-" + (prevMonth) + "-" + (prevDay);
    $("#Txt_FromDate").val(prevToday);
  }

}
